import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download_staging/6a092fa8f6558f0014d4930a/acciodrive/src/app/work-requests/components/WorkRequestsClient.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download_staging/6a092fa8f6558f0014d4930a/acciodrive/src/components/AppLayout.tsx");
